export default __webpack_public_path__ + "static/media/logo_light.258f75f0.svg";